import { useTranslation } from '@kc-console/core';
import { EmptyState } from '@kc-console/shared-ui';
import { IllustStatusResourceMulti, IllustStatusResourceNone } from '@kep/kcds-icons';

import type { ComponentType } from 'react';

type DetailMultiViewEmptyStateType =
  | 'monitoring_limit'
  | 'summary_limit'
  | 'no_content'
  | 'summary_unsupported';

interface DetailMultiViewEmptyStateProps {
  type: DetailMultiViewEmptyStateType;
}

/** 모니터링 탭 다중 선택 임계값 (기본값) */
export const MONITORING_LIMIT = 20;

/** 요약 탭 다중 선택 임계값 (기본값) */
export const SUMMARY_LIMIT = 100;

const config: Record<
  DetailMultiViewEmptyStateType,
  {
    Illustration: ComponentType;
    messageKey: string;
    count?: number;
  }
> = {
  monitoring_limit: {
    Illustration: IllustStatusResourceMulti,
    messageKey: 'common:common.empty.monitoring_selection_limit',
    count: MONITORING_LIMIT,
  },
  summary_limit: {
    Illustration: IllustStatusResourceMulti,
    messageKey: 'common:common.empty.summary_selection_limit',
    count: SUMMARY_LIMIT,
  },
  no_content: {
    Illustration: IllustStatusResourceNone,
    messageKey: 'common:common.empty.no_available_content',
  },
  summary_unsupported: {
    Illustration: IllustStatusResourceNone,
    messageKey: 'common:common.empty.summary_unsupported_service',
  },
};

export default function DetailMultiViewEmptyState({ type }: DetailMultiViewEmptyStateProps) {
  const { t } = useTranslation();
  const { Illustration, messageKey, count } = config[type];

  return (
    <EmptyState
      type="list"
      illustration={<Illustration />}
      message={count != null ? t(messageKey, { count }) : t(messageKey)}
    />
  );
}

export type { DetailMultiViewEmptyStateType, DetailMultiViewEmptyStateProps };
